import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { OffersSelectors } from 'app/modules/communication-centre/advertiser/store/offers/offers.selectors';
import { Localisation, SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { OfferColumnExtractor } from 'app/modules/main/components/offer-selector/offer-column-extractor.service';
import { OfferSelectorMapper } from 'app/modules/main/components/offer-selector/offer-selector-mapper';
import { OfferTypeFilter } from 'app/modules/main/components/offer-selector/offer-type-filter.service';
import { Offer } from 'app/modules/main/models/offers';
import { BehaviorSubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-offer-selector',
  templateUrl: './offer-selector.component.html',
})
export class OfferSelectorComponent implements OnChanges {

  @Input() readonly open: boolean = false;
  @Input() readonly required: boolean = false;
  @Input() readonly singular: boolean = true;

  @Input() readonly localisation?: Localisation = {
    title: $localize`:@@communication-centre.advertiser.offer-selector.title:Select Offer`,
    closeLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.close:Close`,
    searchLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.search:Search`,
    searchPlaceholder: $localize`:@@communication-centre.advertiser.offer-selector.label.search-placeholder:Keyword, Voucher Code or ID`,
    allCategoriesLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.all-categories:All`,
    selectAllLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.select-all:All`,
    selectNoneLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.select-none:None`,
    itemHeaderLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.item-header:Item`,
    selectHeaderLabel: $localize`:@@communication-centre.advertiser.offer-selector.label.select-header:Select`,
    noDataText: $localize`:@@communication-centre.advertiser.offer-selector.no-data:You have no current offers`,
    noMatchesText: $localize`:@@communication-centre.advertiser.offer-selector.no-matches:Your filter criteria did not return any results.`,
    cancelLabel: $localize`:@@communication-centre.advertiser.offer-selector.button.cancel:Cancel`,
    submitLabel: $localize`:@@communication-centre.advertiser.offer-selector.button.submit:Select`,
  };

  @Input() readonly selectedOffers: Offer[];

  @Output() readonly submitted = new EventEmitter<Offer[]>();
  @Output() readonly cancelled = new EventEmitter<void>();

  private initialized = false;

  readonly selectableOffers = new BehaviorSubject<SelectableData<Offer>[]>(null);

  constructor(
    readonly offerColumnExtractor: OfferColumnExtractor,
    readonly offerTypeFilter: OfferTypeFilter,
    private readonly offerSelectorMapper: OfferSelectorMapper,
    private readonly offersSelectors: OffersSelectors,
  ) {
  }

  ngOnChanges(): void {

    if (this.initialized || this.selectedOffers === null) {
      return;
    }

    this.initialized = true;

    this.offersSelectors.getOffers()
      .pipe(
        take(1),
        map(offers => this.offerSelectorMapper.toSelectableOffers(offers, this.selectedOffers)),
      )
      .subscribe(selectableOffers => this.selectableOffers.next(selectableOffers));
  }

  public cancel(): void {
    this.cancelled.emit();
  }

  public submit(
    selectedOffers: SelectableData<Offer>[]
  ): void {

    const offers = this.offerSelectorMapper.toOffers(selectedOffers);

    this.submitted.emit(offers);
  }

}
